import { baseApi } from 'src/api'

export type Branch = {
    id: number;
    name: string;
    isActive: boolean;
}


const apiModule = baseApi.injectEndpoints({
    endpoints: builder => ({
        getBranches: builder.query<Branch[], void>({
            providesTags: ['Branches'],
            query: () => ({
                url: '/branches/',
                method: 'GET',
                errorMessage: 'Не удалось получить информацию о филиалах',
            }),
        }),
    }),
})

export const { useGetBranchesQuery } = apiModule